import { useState, useEffect } from 'react';
import { DEFAULT_SELLING_OFFERS_PRODUCTS_PER_PAGE } from '@constants/negotiation';
import { useGetListSellingOfferProducts } from '@hooks/negotiations/useOffersListQueries';
import { scrollToTop } from '@helpers/utils/general';

interface SellingOffersPresenterProps {
  activePage: number;
  setActivePage: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null | unknown;
  totalCount: number;
  resultsPerPage: number;
}

export const useSellingOffersPresenter = (sellingOffersProductsPaginationMeta): SellingOffersPresenterProps => {
  const [activePage, setActivePage] = useState(1);
  const resultsPerPage = DEFAULT_SELLING_OFFERS_PRODUCTS_PER_PAGE;
  const offset = (activePage - 1) * resultsPerPage;
  const { isLoading, isFetching, error } = useGetListSellingOfferProducts('seller', resultsPerPage, offset);
  const totalCount = sellingOffersProductsPaginationMeta?.totalCount || 0;

  useEffect(() => {
    scrollToTop();
  }, [activePage]);

  return {
    activePage,
    setActivePage,
    isLoading,
    isFetching,
    error,
    totalCount,
    resultsPerPage,
  };
};
